import React, { Suspense } from "react";
import useViewportActivation from "../hooks/useViewportActivation";

const Slider = React.lazy(() => import("react-slick"));

export default function HydrationSafeSlider({ children, className, ...settings }) {
  const [containerRef, isNearViewport] = useViewportActivation();

  if (!isNearViewport) {
    return <div ref={containerRef} className={className}>{children}</div>;
  }

  return (
    <Suspense fallback={<div className={className}>{children}</div>}>
      <Slider {...settings} className={className}>
        {children}
      </Slider>
    </Suspense>
  );
}
